import React, { FunctionComponent } from 'react';
import DisclaimerSection from './DisclaimerSection';
import useCustomizeCarContext from '../../../hooks/useCustomizeCarContext';

const DisclaimerContainer: FunctionComponent = () => {
  const { selectedCar } = useCustomizeCarContext();

  const disclaimerList = selectedCar?.disclaimers ?? [];
  const disclaimerContentValues = {
    vehicle_display_name: selectedCar?.car?.attributes.vehicleDisplayName,
    model: selectedCar?.car?.model?.attributes.shortname,
    bodystyle: selectedCar?.car?.bodyStyle?.attributes.shortname,
  };

  if (disclaimerList.length === 0) {
    return null;
  }
  return <DisclaimerSection disclaimers={disclaimerList} disclaimerContentValues={disclaimerContentValues} />;
};

export default DisclaimerContainer;
